import React from 'react'
import { TitleAniLeft } from '../../component/ScrollTest'
import { ScrollingFormBottom, ScrollingFormTop } from '../../component/ScrollingExample';
import { useLanguage } from '../../i18n/LanguageContext'

function renderItem(item) {
  if (item && typeof item === 'object' && item.type === 'link') {
    return (
      <>
        {item.prefix}
        <a className='expLink' href={item.url} target='_blank' rel='noopener noreferrer'>{item.linkText}</a>
        {item.suffix}
      </>
    )
  }
  return item
}

const COPY = {
  ja: {
    heading: '成長し続けるフルスタックエンジニア',
    items: [
      '許芸瑄 きょ げいせん（Hsu Yun Hsuan）／ 女性 ／ 27歳',
      '世新大学　デジタルマルチメディアデザイン学科　ゲームデザイン専攻　卒業',
      { type: 'link', prefix: '現在：', linkText: '嘉實資訊股份有限公司（MoneyDJ）', suffix: 'にてフルスタックエンジニアとして勤務', url: 'https://www.sysjust.com.tw/About/CompanyProfile.aspx' },
      '得意分野：JavaScript / TypeScript / React',
      '日本語能力試験 N2 取得',
    ],
    dailyTitle: '現在の仕事の日常',
    daily: [
      '新規プロジェクトの開発と、既存プロジェクトの保守運用を両立',
      '日々、メールや電話でお客様とやり取りしながら、お問い合わせ対応を行っています',
      'AIを活用し、業務をより効率的に進められるよう取り組んでいます',
    ],
  },
  zh: {
    heading: '正朝著成為厲害的全端工程師的目標前進',
    items: [
      '許芸瑄 / 女性 / 27歲',
      '世新大學　數位多媒體設計學系　遊戲設計組　畢業',
      { type: 'link', prefix: '目前正於：', linkText: '嘉實資訊股份有限公司（MoneyDJ）', suffix: '任職全端工程師', url: 'https://www.sysjust.com.tw/About/CompanyProfile.aspx' },
      '擅長：JavaScript / TypeScript / React',
      '日文JLPT N2 通過',
    ],
    dailyTitle: '現在工作的日常',
    daily: [
      '開發新專案，同時維運過往專案',
      '每天都得以Email、電話與客戶往來，處理客戶提出的問題',
      '致力於運用AI讓工作更順暢',
    ],
  },
}

export default function About() {
    const { domRefB, formLeftStyleB } = ScrollingFormBottom();
    const { domRefT, formLeftStyleT } = ScrollingFormTop();
    const { lang } = useLanguage()
    const t = COPY[lang]
  return (
    <div>
        <section className="about" id="about">
            <TitleAniLeft title='about' title2='me'/>

            <div className="row">
                <div className="imgcontainer"
                    ref={domRefT}
                    style={{ ...formLeftStyleT }}>
                    <img src={require('../../assets/img/resume_photo.png')} alt=""/>
                    <div className="bg"></div>
                </div>
                <div
                    className="content"
                    ref={domRefB}
                    style={{ ...formLeftStyleB }}>
                    <h3>{t.heading}</h3>
                    <ul>
                        {t.items.map((item, index) => (
                          <li key={index}>{renderItem(item)}</li>
                        ))}
                    </ul>
                    <h4 className='contentSubheading'>{t.dailyTitle}</h4>
                    <ul>
                        {t.daily.map((item, index) => (
                          <li key={index}>{item}</li>
                        ))}
                    </ul>
                </div>
            </div>
        </section>
    </div>
  )
}
